import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/pages`;

const contentPagesService = {
    // Admin methods
    getAll: async () => {
        const response = await axios.get(`${API_URL}/admin`);
        return response.data;
    },
    getById: async (id) => {
        const response = await axios.get(`${API_URL}/admin/${id}`);
        return response.data;
    },
    create: async (data) => {
        const response = await axios.post(`${API_URL}/admin`, data);
        return response.data;
    },
    update: async (id, data) => {
        const response = await axios.put(`${API_URL}/admin/${id}`, data);
        return response.data;
    },
    delete: async (id) => {
        const response = await axios.delete(`${API_URL}/admin/${id}`);
        return response.data;
    },

    // Public methods
    getBySlug: async (slug) => {
        const response = await axios.get(`${API_URL}/public/${slug}`);
        return response.data;
    }
};

export default contentPagesService;
